import React from 'react'
import { css } from '@emotion/core'

type managerCardProps = {
  status?: string
}

export const StatusCard: React.FC<managerCardProps> = ({ status = '' }) => {
  return (
    <div css={wrapperStyle} className={'field'}>
      <div css={positionStyle}>評価登録</div>
      <div css={borderStyle}></div>
      <div css={nameWrapper}>
        <div css={nameStyle}>{status}</div>
      </div>
    </div>
  )
}

const wrapperStyle = css({
  boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.15)',
  backgroundColor: '#FFFFFF',
  borderRadius: '6px',
  minWidth: '266px',
  padding: '20px 26px',
  marginRight: '50px',
  '&:last-child': {
    marginRight: 0,
  },
})
const positionStyle = css({
  color: '#004CAD',
  fontSize: '16px',
  fontWeight: 'bold',
})

const borderStyle = css({
  borderBottom: '1px solid #DDDDDD',
  margin: '12px 0',
  width: '100%',
})
const nameWrapper = css({
  display: 'flex',
})

const nameStyle = css({
  color: '#151619',
  fontSize: '18px',
  lineHeight: '26px',
})
